import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';
import { promotedRecordQuery } from './PromotedRecordQuery';

export class PromotedRecordRef extends Field {
  static subqueriesForModel() {
    return {
      promotable: promotedRecordQuery(),
    };
  }

  get title() {
    return 'Promoted to record reference num';
  }

  exampleContents(): FieldContentsData {
    return { text: 'FWR-12' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.promotable) {
      return {
        text: record.promotable.referenceNum,
      };
    }

    return {};
  }
}
